import { useContext } from 'react';
import { AssetAcquisitionModalContext } from '../contexts/AssetAcquisitionModalContext';

const useAcquisitionModal = () => {
  const modalContext = useContext(AssetAcquisitionModalContext);
  if (!modalContext) {
    throw new Error(
      'useAcquisitionModal must be used within an AssetAcquisitionModalProvider'
    );
  }
  return modalContext;
};

export default useAcquisitionModal;
